/**
 * Scope copy is contractual (design_handoff_integrations_page README §6) —
 * ported verbatim from modals/NewIntegration/GoogleIntegrationForm.js's
 * GoogleScopes and OutlookIntegrationForm.js's IntegrationScopes, including
 * the service-account address in full. Do not reword, shorten, reorder or
 * summarise; single source for both the connect flow and the Settings
 * dialog's Scopes tab.
 */
import React from "react";
import { PLANS } from "../../../../consts";
import ServiceAccountEmailField from "./ServiceAccountEmailField";

export const GoogleScopes = {
  profile: {
    mandatory: true,
    label: "Public profile",
    description:
      "We will pull public profile information to display your name on the integration card.",
  },
  calendar: {
    mandatory: false,
    label: "Calendar API",
    description: "It will allow us to pull events from your calendars.",
  },
  attachments: {
    mandatory: false,
    label: (
      <span>
        Events Attachments (optional){" "}
        <a
          href="https://help.revisual.io/en/articles/9164917-revisual-io-google-calendar-sharing-your-event-images"
          target="_help"
          className="px-2"
        >
          Learn how <i className="material-icons icon-xs">open_in_new</i>
        </a>
      </span>
    ),
    description: (
      <span>
        If you attach an image to an event, we will pull and use it as an event
        cover image. To grant access to your Events attachments, share them with
        the email address: <ServiceAccountEmailField />
      </span>
    ),
  },
  // places scope will be turned off
  // places: {
  //   mandatory: false,
  //   label: "Places (optional)",
  //   description:
  //     "If you set an event location pointing to a place, we will pull and use it for filtering and displaying place details.",
  //   allowedPlans: [PLANS.starter, PLANS.medium, PLANS.highest],
  // },
};

export const OutlookScopes = {
  "User.Read": {
    mandatory: true,
    label: "Profile",
    description:
      "We will pull your profile information to display your name on the integration card.",
  },
  "Calendars.Read": {
    mandatory: false,
    label: "Calendar API",
    description: "It will allow us to pull events from your calendars.",
  },
  attachments: {
    mandatory: false,
    label: "Events Attachments (optional)",
    description:
      "If you attach an image to an event in Outlook Calendar, we'll pull it and use it as the event's cover image.",
  },
};

export const SCOPE_DEFINITIONS = {
  google: GoogleScopes,
  outlook: OutlookScopes,
};
